module.exports = __webpack_public_path__ + "static/reczebtoy-3b764d395bd8a9b62447ab530d93a102.png";